import { NavigationLink } from './NavigationLink/NavigationLink.component';
import { GuideInfoEpisodeList } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC } from 'react';
import { Trans } from 'react-i18next';
import { ChevronLeftIcon } from '@components/icons/ChevronLeft.icon';
import { ChevronRightIcon } from '@components/icons/ChevronRight.icon';
import { Text } from '@components/Text/Text.component';
import { getEpisodeInfos } from '@guides/business/Guides.utils';
import { useTranslation } from '@locales/useTranslation.hook';
import { PlcColor } from '@styles/colors';
import classnames from 'classnames';

import './GuideNavigation.scss';

type Props = ComponentPropsWithRef<'nav'> & {
  guideTitle: string;
  episodeTitle: string;
  episodeList: GuideInfoEpisodeList[];
};

const GuideNavigation: FC<Props> = ({ episodeList, guideTitle, episodeTitle, className, ...rest }) => {
  const { t } = useTranslation(['guides']);
  const rootClass = classnames('guide-navigation', className);
  const { currentEpisode, previousEpisodeSlug, nextEpisodeSlug, isSummary } = getEpisodeInfos(episodeList);
  const titlePrefix = isSummary ? t('guides.summary') : t('guides.current-episode', { current: currentEpisode });

  return (
    <nav className={rootClass} {...rest}>
      <div className="guide-navigation-content flex space-between">
        <NavigationLink className="plc-mr-s plc-mr-up-m-m" slug={previousEpisodeSlug}>
          <ChevronLeftIcon
            className="plc-mr-s"
            fillColor={previousEpisodeSlug ? PlcColor.WHITE : PlcColor.DARK_GREEN}
            height={15}
          />
          <Text
            className="block-up-m none"
            flavour={previousEpisodeSlug ? 'light' : 'dark-green'}
            tag="span"
            variant="h6"
          >
            <Trans i18nKey="guides.previous" ns="guides" />
          </Text>
        </NavigationLink>
        <div className="guide-navigation-titles">
          <Text alignment="center" className="plc-mb-xs plc-mb-up-m-s" flavour="light" tag="p" variant="tiny-title">
            {guideTitle}
          </Text>
          <Text alignment="center" flavour="light" tag="p" variant="h4">
            {titlePrefix}&nbsp;:&nbsp;{episodeTitle}
          </Text>
        </div>
        <NavigationLink className="plc-ml-s plc-ml-up-m-m" slug={nextEpisodeSlug}>
          <Text
            alignment="right"
            className="none block-up-m"
            flavour={nextEpisodeSlug ? 'light' : 'dark-green'}
            tag="span"
            variant="h6"
          >
            <Trans i18nKey="guides.next" ns="guides" />
          </Text>
          <ChevronRightIcon
            className="plc-ml-s"
            fillColor={nextEpisodeSlug ? PlcColor.WHITE : PlcColor.DARK_GREEN}
            height={15}
          />
        </NavigationLink>
      </div>
    </nav>
  );
};

export { GuideNavigation };
